module.exports = __webpack_public_path__ + "static/img/m_role.7fa1b08.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/bn/m_role.png
// module id = 5DUl
// module chunks = 7